import { UserActionType } from "./action-type"

export const actionLoginUser = (payload, callBack) => ({
    type: UserActionType.LOGIN,
    payload,
    callBack
});

export const actionRegisterUser = (payload, callBack) => ({
    type: UserActionType.CREATE,
    payload,
    callBack
});

export const actionLoggoutUser = () => ({
    type: UserActionType.LOGOUT
});

export const actionTypeBenefitUser = (callBack) => ({
    type: UserActionType.TYPE_BENEFIT,
    callBack
});

export const actionForgotPasswordUser = ({ email, cpf }, callBack) => ({
    type: UserActionType.FORGOT_PASSWORD,
    payload: { email, cpf },
    callBack
});

